import React, { useContext } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field, getFormValues } from 'redux-form';
import { BodyText, CaptionText } from '@paypalcorp/pp-react';
import { BTN_FACTORY_V3_FORM } from '../../clientConstants';
import CheckboxGroupField from '../fields/CheckboxGroupField';
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react';
import { Message } from '@paypalcorp/worldready-react';
import { MessageFormat } from '@paypalcorp/worldready';
import { getUserType } from '../../utilsV3/authUtils';

const renderFrequencyOption = (props) => {
  return <CheckboxGroupField {...props} />;
};

const RecurringFrequencyOptions = ({ formValues }) => {
  const worldReady = useContext(WorldReadyContext);
  const optionsList = [
    {
      id: 'Weekly',
      label: new MessageFormat(worldReady, {
        id: 'buttonsV3.recurringFrequencyOptions.recurringWeekly',
      }).format(),
      name: 'Weekly',
    },
    {
      id: 'Monthly',
      label: new MessageFormat(worldReady, {
        id: `buttonsV3.recurringFrequencyOptions.recurringMonthly`,
      }).format(),
      name: 'Monthly',
    },
    getUserType() !== 'PERSONAL' && {
      id: 'Yearly',
      label: new MessageFormat(worldReady, {
        id: 'buttonsV3.recurringFrequencyOptions.recurringYearly',
      }).format(),
      name: 'Yearly',
    },
  ];
  return (
    <div className="recurring-frequency-options">
      <BodyText>
        <Message id="buttonsV3.recurringFrequencyOptions.recurringLabel" />
      </BodyText>
      <CaptionText>
        <Message id="buttonsV3.recurringFrequencyOptions.recurringSubLabel" />
      </CaptionText>
      <Field
        id="frequencies"
        name="frequencies"
        component={renderFrequencyOption}
        options={optionsList}
        checkedFrequencies={formValues.frequencies}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  const { application = {}, buttonFactoryV3 = {} } = state;

  return {
    application,
    buttonFactoryV3,
    formValues: getFormValues(BTN_FACTORY_V3_FORM)(state),
    initialValues: buttonFactoryV3.formattedButton,
  };
};

RecurringFrequencyOptions.propTypes = {
  formValues: PropTypes.object,
};

export default connect(mapStateToProps)(RecurringFrequencyOptions);
